export const gitCommit = '40cc851a'
